import React from 'react';
import './LegalPage.css';

const LegalPage: React.FC = () => {
  return (
    <div className="legal-page">
      <div className="legal-content">
        <h1>Legal & Attribution</h1>

        <section className="legal-section">
          <h2>Copyright & Attribution</h2>
          <p>
            This product includes materials from the Daggerheart System Reference Document 1.0, © Critical Role, LLC. under the terms of the Darrington Press Community Gaming (DPCGL) License. More information can be found at{' '}
            <a
              href="https://www.daggerheart.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.daggerheart.com
            </a>
            . There are no previous modifications by others.
          </p>
        </section>

        <section className="legal-section">
          <h2>Resources</h2>
          <ul>
            <li>
              <a
                href="https://darringtonpress.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Darrington Press
              </a>
            </li>
            <li>
              <a
                href="https://www.daggerheart.com/srd/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Daggerheart SRD
              </a>
            </li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>Disclaimer</h2>
          <p>
            This is an unofficial tool. It is not affiliated with, endorsed by, or sponsored by Darrington Press LLC, Critical Role LLC, Critical Role Productions LLC, or Gilmore's Glorious Goods LLC.
          </p>
        </section>
      </div>
    </div>
  );
};

export default LegalPage;
